import { User } from '../components/types/user';
import { getApiHost } from './hosts';
import logger from './logger-rum';

export async function sendStylePackSlackMessage(
	type: string,
	user: User,
): Promise<boolean> {
	try {
		const result = await fetch(
			`${getApiHost()}/v2/greenroom/post-slack-stylepack-request/${type}`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(user),
			},
		);

		const response = await result.json();
		if (response.success) {
			return true;
		}
	} catch (error) {
		logger.error(error);
	}

	return false;
}
